export const lightTheme = {
  background: '#EBF4F8',
  titles: '#010103',
  text: '#2C2738',
  accent: '#0880AE',
}

export const darkTheme = {
  background: '#1C2025',
  titles: '#D6E1DF',
  text: '#D6E1DF',
  accent: '#8A85FF',
}
